// extracted by mini-css-extract-plugin
export var filterForm = "PostsModuleGridLayout-module--filterForm--PV6Re";